import { ProtectedJsonAPI } from '.'

export const Organisation = ProtectedJsonAPI.extend(
  '/organisation',
  {
    show:    endpoint => endpoint,
    update:  endpoint => endpoint.method('put'),
  }
)